import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMisc } from "../../../apiclients/streamsapi_bridge";

function PhoneNumberGeneral({ register, watch, errors, setValue }) {
  const { t, i18n } = useTranslation();
  const [allLocations, setAllLocations] = useState([]);
  const [billinggroups, setbillinggroups] = useState([]);

  async function fetchLocation() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["all_locations", "billinggroups"],
      };

      const serverResponse = await getMisc(siteid, params);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const responseData = await serverResponse.json();
        console.log("Response Data:", JSON.stringify(responseData));
        // const transformedLocationsList = (responseData.misc.all_locations|| []).map(locations => ({ text: locations.loc_name, value: locations.loc_id }));
        setAllLocations(responseData.misc.all_locations || []);
        setbillinggroups(responseData.misc.billinggroups || []);
      }
    } catch (error) {
      console.error("[fetchAddLocationMisk] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  useEffect(() => {
    fetchLocation();
  }, []);

  return (
    <>
      <div className="margin-top huntgroup">
        <div className="general-settings" id="general">
          {t("general")}
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("CallerIDname")}</div>

          <div className="phoneselect w-30 ">
            <input
              type="text"
              className="form-control w-100"
              {...register("general.alias_name", {
                validate: (value) => {
                  let inputValue = value?.trim() || "";

                  if (inputValue === "") {
                    return true; // empty allowed
                  }
                  else if (!/^[A-Za-z0-9.,&\-_' ]+$/.test(inputValue)) {
                    return "Invalid characters";
                  }
                  else if (/^\d+$/.test(inputValue)) {
                    return "Must contain at least one letter";
                  }
                  else if (inputValue.length < 2) {
                    return "Minimum 2 characters required";
                  }
                  else if (inputValue.length > 15) {
                    return "Maximum 15 characters allowed";
                  }
                  else if (!/[A-Za-z]/.test(inputValue)) {
                    return "Must contain at least one letter";
                  }
                  else {
                    return true;
                  }
                }
              })}
            />
            {errors?.general?.alias_name && (
              <p className="text-danger text-start">
                {errors.general.alias_name.message}
              </p>
            )}
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("location")}</div>

          <div className="phoneselect w-30">
            <select
              className="form-control form-select w-100 selectname"
              value={watch("general.location_id")}
              onChange={(e) => {
                setValue("general.location_id", parseInt(e.target.value), {
                  shouldDirty: true,
                });
              }}

            //  {...register("general.location_id", { setValueAs: (value) =>Number(value)})}
            >
              {allLocations &&
                allLocations.map((loc) => (
                  <option value={parseInt(loc.loc_id)}>{loc.loc_name}</option>
                ))}
            </select>
            {/* <input
                type="text"
                {...register("general.location_id")}
                className="selectname"
              /> */}
            {errors?.general?.location_id && (
              <p className="text-danger">
                {errors?.general?.location_id.message}
              </p>
            )}
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("billing_Group")}</div>

          <div className="phoneselect w-30">
            {/* <input
                type="text"
                // value="Sales"
                {...register("general.billing_grp")}
                className="selectname"
              /> */}
            <select
              className="form-control form-select selectname"
              // {...register("general.billing_grp", {
              //   setValueAs: (value) => Number(value),
              // })}
              value={parseInt(watch("general.billing_grp"))}
              onChange={(e) => {
                setValue("general.billing_grp", parseInt(e.target.value), {
                  shouldDirty: true,
                });
              }}
            >
              {billinggroups &&
                billinggroups.length > 0 &&
                billinggroups.map((group) => (
                  <option value={parseInt(group.groupid)}>{group.groupname}</option>
                ))}
            </select>
            {errors?.general?.billing_grp && (
              <p className="text-danger">
                {errors?.general?.billing_grp.message}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="routing-border mb-4"></div>
    </>
  );
}

export default PhoneNumberGeneral;
